import { HeaderBareboneProps } from "@made-people/blueprint-header";
import { MissMaryLogo } from "../../../assets/icons/MissMaryLogo";
import { CartIcon } from "../../../assets/icons/Cart";
import { MagnifierIcon } from "../../../assets/icons/Magnifier";

export const HeaderBarebone: HeaderBareboneProps = {
  logo: {
    svg: <MissMaryLogo />,
  },
  cartTrigger: {
    type: "mini-cart",
    icon: {
      iconSvg: <CartIcon />,
    },
  },
  accountTrigger: {
    enabled: true,
    href: "comfort-club",
  },
  searchTrigger: {
    icons: {
      default: <MagnifierIcon />,
    },
  },
  search: {
    autoComplete: {
      enabled: true,
    },
  },
};
